import { useEffect, useRef } from 'react';

const features = [
  { icon: 'ri-settings-3-line', label: '컨베이어 시스템' },
  { icon: 'ri-robot-line', label: '자동화 생산라인' },
  { icon: 'ri-hammer-line', label: '특수 산업기계' },
  { icon: 'ri-bar-chart-box-line', label: '공정 최적화 설계' },
];

export default function IndustrialSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.fade-in-item').forEach((el, i) => {
              setTimeout(() => {
                (el as HTMLElement).style.opacity = '1';
                (el as HTMLElement).style.transform = 'translateY(0)';
              }, i * 130);
            });
          }
        });
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const handleContact = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="industrial" className="bg-[#FAF8F3] py-0 overflow-hidden" ref={sectionRef}>
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[680px]">
        {/* Left: Image */}
        <div className="relative overflow-hidden">
          <img
            src="https://public.readdy.ai/ai/img_res/baaf834fc72947588bfd6930cefb1f94.jpg"
            alt="산업기계설비"
            className="w-full h-full object-cover object-top"
          />
          {/* Overlay Text */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
          <div className="absolute bottom-12 left-10">
            <p className="text-xs font-bold tracking-widest text-white/60 mb-3">INDUSTRIAL MACHINERY</p>
            <h3 className="text-5xl font-black text-white leading-tight">
              최첨단<br />
              <span className="font-light">산업기계</span><br />
              설비
            </h3>
          </div>
        </div>

        {/* Right: Content */}
        <div className="bg-white flex flex-col justify-center px-10 lg:px-16 py-20">
          <div
            className="fade-in-item"
            style={{ opacity: 0, transform: 'translateY(24px)', transition: 'opacity 0.7s ease, transform 0.7s ease' }}
          >
            <span className="inline-block text-xs font-bold tracking-widest text-[#C0392B] border border-[#C0392B]/30 px-3 py-1 rounded-full mb-6">
              산업설비
            </span>
            <h2 className="text-3xl lg:text-4xl font-black text-[#1C1C1C] leading-tight mb-6">
              정밀하고 효율적인<br />
              산업기계설비
            </h2>
            <p className="text-gray-600 leading-relaxed mb-8 text-sm">
              에스제이엔지니어링은 컨베이어 시스템, 자동화 생산라인, 물류 자동화 설비 등
              다양한 산업기계설비를 설계·제작·설치합니다. 고객의 생산 공정을 철저히 분석하여
              최적의 효율성과 안전성을 갖춘 맞춤형 솔루션을 제공합니다.
            </p>
            <p className="text-gray-600 leading-relaxed mb-10 text-sm">
              자동차, 조선, 전자, 철강, 식품 등 다양한 산업 분야의 현장에 검증된 설비를 공급하며,
              국내외 주요 기업들의 생산성 향상에 기여해 왔습니다.
            </p>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-2 gap-4 mb-10">
            {features.map((f, i) => (
              <div
                key={f.label}
                className="fade-in-item flex items-center gap-3 bg-[#F8F6F2] rounded-xl px-4 py-3"
                style={{
                  opacity: 0,
                  transform: 'translateY(20px)',
                  transition: `opacity 0.6s ease ${0.15 + i * 0.1}s, transform 0.6s ease ${0.15 + i * 0.1}s`,
                }}
              >
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-[#C0392B]/10">
                  <i className={`${f.icon} text-[#C0392B]`} />
                </div>
                <span className="text-xs font-semibold text-[#1C1C1C]">{f.label}</span>
              </div>
            ))}
          </div>

          <div
            className="fade-in-item"
            style={{ opacity: 0, transform: 'translateY(20px)', transition: 'opacity 0.6s ease 0.5s, transform 0.6s ease 0.5s' }}
          >
            <button
              onClick={handleContact}
              className="flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#1C1C1C] text-white font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-[#C0392B] transition-all duration-200"
            >
              <i className="ri-phone-line" />
              제품 상담하기
              <i className="ri-arrow-right-line" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
